// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"e1c25133","103":"2fc06263","638":"da3629bc","787":"ee4d86e2"}[chunkId] + ".chunk.js";
};